import { useFindByQuery } from '../../graphql';

const FIND_WORKSPACE_ASSET = `
  query FindAssetByLink($filter: AssetFilter) {
    findAssets(filter: $filter) {
      items {
        id
      }
    }
  }
`;

export const useFindAssetIdForWorkspace = (workspaceId: string) => {
  const { data, isLoading } = useFindByQuery({
    modelName: 'asset',
    query: FIND_WORKSPACE_ASSET,
    variables: {
      filter: {
        json: {
          'link.linkData.id': workspaceId,
        },
      },
    },
    options: {
      enabled: !!workspaceId,
    },
  });

  return {
    assetId: data?.items?.[0]?.id as string | undefined,
    isLoading,
  };
};
